import { faCartShopping } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { Dropdown, DropdownButton, DropdownContent, Spacer } from "@aviary";
import { EmersonCartPopup } from "@emerson/components/EmersonCartPopup/EmersonCartPopup";
import { l } from "@emerson/locales/i18n";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useCartUnitCount } from "@shared/hooks/useCartUnitCount/useCartUnitCount";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import { MultiCart } from "../MultiCart/MultiCart";

import * as styles from "./EmersonMiniCart.styles";

const EmersonMiniCart = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  const numberOfCartItems = useCartUnitCount();

  return (
    <>
      <Dropdown dropdownPlacement="bottom-end" isFullHeight>
        <DropdownButton data-testid="emerson-mini-cart-button" hasIcon={false} isColor="primary">
          <>
            <FontAwesomeIcon icon={faCartShopping} size="1x" />
            {!!tablet.greaterThan && (
              <>
                <Spacer width="half" />
                <span data-testid="emerson-cart-count-badge" data-e2e="emerson-cart-quantity">
                  {t(l.header.Cart, { numberOfCartItems })}
                </span>
              </>
            )}
          </>
        </DropdownButton>
        <DropdownContent css={styles.content}>
          <EmersonCartPopup />
        </DropdownContent>
      </Dropdown>
      <MultiCart />
    </>
  );
};

export { EmersonMiniCart };
